import React, {useReducer, useState} from 'react';
import {BaseIndexScreen} from 'src/design-system';
import {Calendar} from 'src/modules/scheduling/components';
import {View} from 'react-native';
import {withObservables} from '@nozbe/watermelondb/react';
import {withDatabase} from '@nozbe/watermelondb/react';
import {compose} from 'recompose';
import withState from 'src/redux/wrapper';
import {of} from 'rxjs';
import DeleteSessionModal from '../../components/delete-session-modal';
import {useStyle} from 'src/providers/style';
import SchedulingDrawer from 'src/modules/scheduling/components/scheduling-drawer';
import SchedulingImport from 'src/modules/scheduling/components/scheduling-import';
import {useTranslations} from 'src/providers/translation';
import {useNavigation} from '@react-navigation/native';
import {useSelector} from 'react-redux';
import {Modal} from 'src/design-system';
import RadioInput from 'src/hook-form-wrapper/radio-input';
import {FormProvider, useForm, useWatch} from 'react-hook-form';
import {RHButton} from 'src/common-components/custom-ui-helpers';

function CalendarScreen({profile, role}: any) {
  const styles = useStyle();
  const translations = useTranslations();
  const navigation = useNavigation();
  const [eventModal, setEventModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const [update, forceUpdate] = useReducer((x: number) => x + 1, 0);
  const [showDelete, setShowDelete] = useState<any | boolean>(false);

  const {selectedFilters} = useSelector(state => state.schedulingFilters);
  const initialValues = {
    event: 'session',
  };

  const methods = useForm({
    defaultValues: initialValues,
  });
  const watchedEvent = useWatch({
    control: methods.control,
    name: 'event',
  });
  const addCallback = (event: any) => {
    setSelectedEvent(event);
    setEventModal(true);
  };

  const editCallback = (event: any, date: Date) => {
    navigation.navigate('ScheduleAppointment', {
      id: event.id,
      date,
    });
  };

  const deleteCallback = (
    appointment: any,
    date: any,
    supervision: any,
    dtSession: any,
  ) => {
    setShowDelete({
      appointment,
      date,
      supervision,
      dtSession,
    });
  };

  const deleteCancelled = () => {
    setShowDelete(false);
    forceUpdate();
  };

  return (
    <BaseIndexScreen header={false} title={translations('schedule')}>
      <SchedulingImport />
      <DeleteSessionModal
        show={[showDelete, setShowDelete]}
        deleteCancelled={() => deleteCancelled()}
      />
      <Modal show={[eventModal, setEventModal]} title={'Event Type'}>
        <FormProvider {...methods}>
          <RadioInput
            name={'event'}
            label={''}
            required={false}
            items={[
              {value: 'session', label: 'Clinical Session'},
              {value: 'event', label: 'General Event'},
            ]}
          />
          <View style={[styles.row, styles.alignCenter, styles.justifyEnd]}>
            <RHButton
              secondary
              mode="contained"
              onPress={() => {
                navigation.navigate('ScheduleAppointment', {
                  date: selectedEvent?.date,
                  start: selectedEvent?.date,
                  type: watchedEvent,
                });
              }}>
              {'Continue'}
            </RHButton>
          </View>
        </FormProvider>
      </Modal>
      <View style={[styles.height, styles.flex, styles.row]}>
        <SchedulingDrawer
          role={role}
          selectedFilters={selectedFilters}
          setEventModal={setEventModal}
        />
        <View style={[styles.flex, styles.backgroundColorWhite]}>
          <Calendar
            update={update}
            filters={selectedFilters}
            profile={profile}
            role={role}
            canAdd={role?.appointmentCreate}
            addCallback={addCallback}
            canEdit={role?.appointmentEdit}
            editCallback={editCallback}
            canDelete={role?.appointmentDelete}
            deleteCallback={deleteCallback}
          />
        </View>
      </View>
    </BaseIndexScreen>
  );
}

export default compose(
  withDatabase,
  withState,
  withObservables(['authentication'], ({authentication, database}: any) => ({
    profile: authentication.userId
      ? database.get('users').findAndObserve(authentication.userId)
      : of(),
  })),
  withObservables([], ({profile}: any) => {
    return {
      role: profile.role,
    };
  }),
)(CalendarScreen);
